import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from 'components';
import { useIntl } from 'react-intl';

const SearchFooterContainer = styled.div`
  width: 100%;
  height: 65px;
  border-top: 1px solid #d7d6e0;

  display: flex;
  justify-content: space-between;
  align-items: center;

  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #ffffff;
`;

const SearchFooter = ({
  onForwarClick,
  children,
  currentStep,
  onCancelClick,
}) => {
  const intl = useIntl();

  return (
    <SearchFooterContainer>
      <Button
        onClick={currentStep === 2 ? onCancelClick : onForwarClick}
        width="130px"
        height="130px"
        margin="0 0 0 26px"
        backgroundHover="transparent"
        colorHover="#000"
      >
        {currentStep === 2
          ? intl.formatMessage({
            id: 'main-page.cancel',
          })
          : intl.formatMessage({
              id: 'main-page.skip',
            })}
      </Button>
      <Button
        onClick={onForwarClick}
        margin="0 26px 0 0"
        primary
        width="130px"
        height="130px"
      >
        {children}
      </Button>
    </SearchFooterContainer>
  );
};

export default SearchFooter;
